import { render, staticRenderFns } from "./CurrentLegislation.vue?vue&type=template&id=1f2819ba&"
import script from "./CurrentLegislation.vue?vue&type=script&lang=js&"
export * from "./CurrentLegislation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports